// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ShdD","top":"styles_top__Xolko","left":"styles_left__3GehG","description":"styles_description__2FpAN"};